import type { ComponentProps, JSX } from 'react';
import type { DayPickerSingleProps } from 'react-day-picker';

import { Text } from '~/components/text';
import { Calendar } from '~/components/calendar';
import { cn, formatDate, wrapArray } from '~/utils';
import { Popover, PopoverContent, PopoverTrigger } from '~/components/popover';

interface IDatePickerProps extends Omit<DayPickerSingleProps, 'mode'> {
  to?: Date;
  from?: Date;
  value?: Date;
  triggerProps?: ComponentProps<typeof PopoverTrigger>;
}

export function DatePicker({
  to,
  from,
  value,
  disabled,
  triggerProps = {},
  ...props
}: IDatePickerProps): JSX.Element {
  const { className: triggerClassName, ...triggerRest } = triggerProps;

  const handleDisabled = (date: Date) => {
    return (!!from && date < from) || (!!to && date > to);
  };

  return (
    <Popover>
      <PopoverTrigger
        className={cn('text-left', triggerClassName)}
        {...triggerRest}
      >
        <Text className='text-dimGray-500 text-sm cursor-pointer'>
          {value
            ? formatDate(value, {
                format: 'dd/MM/yyyy',
              })
            : 'dd/mm/yyyy'}
        </Text>
      </PopoverTrigger>
      <PopoverContent className='w-auto p-0'>
        <Calendar
          initialFocus
          mode='single'
          selected={value}
          disabled={[handleDisabled, ...wrapArray(disabled)]}
          {...props}
        />
      </PopoverContent>
    </Popover>
  );
}
